import {
  ChatBubbleOvalLeftEllipsisIcon as ChatIcon,
  HomeIcon,
  MagnifyingGlassIcon as SearchIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";
import Notifications from "./Notifications";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const { darkMode } = useContext(ThemeContext);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const selectedIconColor = darkMode ? "text-gray-100" : "text-gray-800";
  const nonSelectedIconColor = darkMode ? "text-gray-700" : "text-gray-400";
  return (
    <div
      className={`min-h-screen ${
        darkMode ? "bg-gray-950 text-white" : "bg-gray-50 text-black"
      } overflow-x-hidden`}
    >
      <header
        className={`${
          darkMode ? "bg-gray-950" : "bg-white"
        } border-b-0 sticky top-0 z-10`}
      >
        <div className="flex flex-col items-center justify-between max-w-5xl px-4 py-3 mx-auto sm:flex-row">
          <Link to="/" className="mb-2 text-xl font-semibold sm:mb-0">
            PkGram
          </Link>
          <form
            onSubmit={handleSearch}
            className="w-full mx-4 mb-2 sm:w-auto sm:flex-grow sm:max-w-xs sm:mb-0"
          >
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search..."
              className={`w-full p-2 ${
                darkMode ? "bg-gray-800" : "bg-gray-100"
              } rounded-md`}
            />
          </form>
          <div className="flex items-center space-x-4">
            <Notifications />

            <Link to="/profile">
              <img
                src={portfolioConfig.avatar}
                alt="Profile"
                className="w-8 h-8 rounded-full"
              />
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-5xl px-4 py-8 mx-auto">{children}</main>

      <nav
        className={`fixed bottom-0 left-0 right-0 ${
          darkMode ? "bg-gray-950" : "bg-white"
        } border-b-0`}
      >
        <div className="flex justify-between max-w-5xl px-4 py-3 mx-auto">
          <Link to="/">
            <HomeIcon
              className={`h-6 w-6 ${
                location.pathname === "/"
                  ? selectedIconColor
                  : nonSelectedIconColor
              }`}
            />
          </Link>
          <Link to="/explore">
            <SearchIcon
              className={`h-6 w-6 ${
                location.pathname === "/explore"
                  ? selectedIconColor
                  : nonSelectedIconColor
              }`}
            />
          </Link>
          {/* <button>
            <PlusCircleIcon className="w-6 h-6 text-gray-500" />
          </button> */}
          <Link to="/messages">
            <ChatIcon
              className={`h-6 w-6 ${
                location.pathname === "/messages"
                  ? selectedIconColor
                  : nonSelectedIconColor
              }`}
            />
          </Link>
          <Link to="/profile">
            <UserCircleIcon
              className={`h-6 w-6 ${
                location.pathname === "/profile"
                  ? selectedIconColor
                  : nonSelectedIconColor
              }`}
            />
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default Layout;
